import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {ActivatedRoute} from '@angular/router';
import {FormModel} from '../../../common/components/form/models';
import {ResponseForm} from '../../../common/components/form/models/responsedemat.model';
import {SubSink} from '@Common/core/utils/subsink';
import {TypeDemandes} from "app/demat/gestion/demandes/formulaires-demandes-liste/type-demandes.enum";

@Component({
  selector: 'app-list-home',
  templateUrl: './list-home.component.html',
  styleUrls: ['./list-home.component.scss']
})
export class ListHomeComponent implements OnInit, OnDestroy {
  index = 0;
  formModel: FormModel;
  selectedResponses: ResponseForm[] = [];
  IDX_TAB_LIST = 0;
  IDX_TAB_LIST_ARCHIVED = 1;
  subSink = new SubSink();
  filterState = null;
  constructor(private route: ActivatedRoute,
              private formulaireSvc: FormulaireService) { }

  ngOnInit(): void {
    const param = this.route.snapshot.paramMap.get('id');
    this.filterState = this.route.snapshot.paramMap.get('state');

    if (Number(this.filterState) === TypeDemandes.Archivees) {
      this.index = this.IDX_TAB_LIST_ARCHIVED;
    }

    this.subSink.sink = this.formulaireSvc.get(param).subscribe(_form => this.formModel = _form);
  }
  closeTab(e: Event, t: ResponseForm) {
    e.stopImmediatePropagation();
    this._removeFicheTab(t);
  }
  onSelectedResponse(response: ResponseForm, begin) {
    this.selectedResponses.push(response);
    setTimeout(() => this.index = begin + this.selectedResponses.length + 1);
  }
  private _removeFicheTab(t: ResponseForm) {
    const index = this.selectedResponses.indexOf(t);
    if (index > -1) {
      this.selectedResponses.splice(index, 1);
      if (this.selectedResponses.length === 0) {
        this.index = 0;
      }
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
